// extracted by mini-css-extract-plugin
module.exports = {"heading":"GemDetail_heading__1n2Lj","list":"GemDetail_list__1TbHk","li":"GemDetail_li__2UtyA"};